import type { IMenu } from "../../../../constants";
import SubMenuDesktop from "./desktop/subMenuDesktop";
import SubMenuMobile from "./mobile/SubMenuMobile";
import styles from "./subMenu.module.scss";

interface SubMenuProps {
  menuItem: IMenu;
  onCloseDrawer?: (() => void) | undefined;
}

const SubMenu = (props: SubMenuProps) => {
  const { menuItem, onCloseDrawer } = props;
  return (
    <div className={styles["sub-menu"]}>
      <div className={styles["sub-menu__mobile"]}>
        <SubMenuMobile menuItem={menuItem} onCloseDrawer={onCloseDrawer} />
      </div>
      <div className={styles["sub-menu__desktop"]}>
        <SubMenuDesktop menuItem={menuItem} />
      </div>
    </div>
  );
};

export default SubMenu;
